import { ClientFeedData } from '@act/shared/types';

export function getClientFeedDataForSection(
  clientFeedData: ClientFeedData[],
  sectionTag: string
) {
  const clientFeedDataForSection = clientFeedData?.filter(
    data => data.field_section === sectionTag
  );
  const sortedClientFeedData = clientFeedDataForSection?.sort(
    (a, b) => a.sort_order - b.sort_order
  );
  return sortedClientFeedData;
}
